export const STORAGE_KEYS = Object.freeze({
  language: Object.freeze({ current: 'agrilink-language', legacy: ['agrisense-language'] }),
  session: Object.freeze({ current: 'agrilink-session', legacy: ['agrisense-session'] }),
  theme: Object.freeze({ current: 'agrilink-theme', legacy: ['agrisense-theme'] }),
  settings: Object.freeze({ current: 'agrilink-settings', legacy: ['agrisense-settings'] }),
  demoUsers: Object.freeze({ current: 'agrilink-demo-users', legacy: ['agrisense-demo-users'] }),
  sidebarCollapsed: Object.freeze({ current: 'agrilink-sidebar-collapsed', legacy: ['agrisense-sidebar-collapsed'] }),
  selectedFarm: Object.freeze({ current: 'agrilink-selected-farm', legacy: ['agrisense-selected-farm'] }),
  userRole: Object.freeze({ current: 'agrilink-user-role', legacy: ['agrisense-user-role'] }),
  analyticsSelection: Object.freeze({
    current: 'agrilink-analytics-section-selection',
    legacy: ['agrisense-analytics-section-selection'],
  }),
});

export const STORAGE_PREFIXES = Object.freeze({
  reportDraft: Object.freeze({ current: 'agrilink:report-draft', legacy: ['agrisense:report-draft'] }),
  reportExport: Object.freeze({ current: 'agrilink:report-export', legacy: ['agrisense:report-export'] }),
  reportModuleBlocks: Object.freeze({
    current: 'agrilink:report-module-blocks',
    legacy: ['agrisense:report-module-blocks'],
  }),
  reportStepperProgress: Object.freeze({
    current: 'agrilink:report-stepper-progress',
    legacy: ['agrisense:report-stepper-progress'],
  }),
});

const toArray = (value) => {
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === 'string' && value) {
    return [value];
  }
  return [];
};

const withSuffix = (key, suffix = '') => (suffix ? `${key}:${suffix}` : key);

const getLegacyKeys = (spec) => toArray(spec?.legacy);

export const getPrimaryStorageKey = (spec, suffix = '') => withSuffix(spec.current, suffix);

export const getStorageCandidates = (spec, options = {}) => {
  const suffix = options.suffix || '';
  return [
    withSuffix(spec.current, suffix),
    ...getLegacyKeys(spec).map((legacyKey) => withSuffix(legacyKey, suffix)),
  ];
};

export const getCandidateKeysFromCurrentKey = (currentKey, spec) => {
  if (!currentKey || typeof currentKey !== 'string') {
    return [];
  }
  if (!spec?.current || !currentKey.startsWith(spec.current)) {
    return [currentKey];
  }
  const suffix = currentKey.slice(spec.current.length);
  return [
    currentKey,
    ...getLegacyKeys(spec).map((legacyKey) => `${legacyKey}${suffix}`),
  ];
};

export const readStorageValue = (storage, spec, options = {}) => {
  if (!storage) {
    return null;
  }
  const candidates = getStorageCandidates(spec, options);
  for (const key of candidates) {
    try {
      const value = storage.getItem(key);
      if (value !== null && value !== undefined) {
        return { key, value };
      }
    } catch (error) {
      return null;
    }
  }
  return null;
};

export const writeStorageValue = (storage, spec, value, options = {}) => {
  if (!storage) {
    return null;
  }
  const [primaryKey, ...legacyKeys] = getStorageCandidates(spec, options);
  storage.setItem(primaryKey, value);
  legacyKeys.forEach((legacyKey) => {
    if (legacyKey !== primaryKey) {
      storage.removeItem(legacyKey);
    }
  });
  return primaryKey;
};

export const removeStorageValue = (storage, spec, options = {}) => {
  if (!storage) {
    return;
  }
  getStorageCandidates(spec, options).forEach((key) => {
    storage.removeItem(key);
  });
};
